



































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HomeModules extends Vue {
  startAcquisition() {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Home Modules NewRunningAnalysis Click');

    this.$emit('startAcquisition');
  }
}
